import { settings } from "app";
import { Datagrid, FunctionField, NumberField, ReferenceField, SelectField, TextField } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { NationalityType } from "utils/choices";
import RowActions from "./RowActions";

const StateExamsGrid = ({ collection }) => (
  <Datagrid
    bulkActionButtons={false}
    rowClick={false}
    sx={[settings.style.detailsDatagrid, { "& .RaDatagrid-headerCell": { textAlign: "left" } }]}
  >
    <ReferenceField
      source="stateExamId"
      reference={administrationRequests.getStateExamsSelect()}
      label="Държавен изпит"
      link={false}
      sortable={false}
      emptyText="-"
    >
      <TextField
        source="name"
        emptyText="-"
      />
    </ReferenceField>
    <SelectField
      source="nationality"
      choices={NationalityType}
      label="Националност"
      sortable={false}
      emptyText="-"
    />
    <ReferenceField
      source="instructionLanguageId"
      reference={administrationRequests.getInstructionLanguagesSelect()}
      label="Език"
      link={false}
      sortable={false}
      emptyText="-"
    >
      <TextField
        source="name"
        emptyText="-"
      />
    </ReferenceField>
    <NumberField
      source="credits"
      label="Кредити"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <FunctionField
      label=""
      sortable={false}
      render={() => <RowActions collection={collection} />}
    />
  </Datagrid>
);

export default StateExamsGrid;
